import React from 'react';
import './App.css';
import HomePage from './pages';

function App() {
  return <HomePage />;
}

export default App;
